import { request } from '@/utils/request'

export function recommendedVideo(params?: any, data?: any) {
  return request({ url: '/video/recommended', method: 'get', params, data })
  // return request({ url: '/?_Action=short&_Method=collection', method: 'get', params, data })
}
